import { gql } from '@apollo/client'

export const LIST_LOCATION_METRIC_VALUES_V2 = gql`
  query listLocationMetricValuesV2(
    $iStartDate: Date!
    $iEndDate: Date!
    $iParams: JSON!
  ) {
    listLocationMetricValuesV2(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iParams: $iParams
    ) {
      nodes {
        locationId
        locationCode
        locationName
        startDate
        endDate
        metricData
      }
    }
  }
`

interface IMetricDataType {
  name: string
  unit: string
  value: number
}

export interface ILocationMetricNode {
  locationId: number
  locationCode: string
  locationName: string
  startDate: string
  endDate: string
  metricData: Record<string, IMetricDataType>
}

export interface IListLocationMetricValuesV2Response {
  listLocationMetricValuesV2: {
    nodes: ILocationMetricNode[]
  }
}

export interface IListLocationMetricValuesV2Variables {
  iStartDate: string
  iEndDate: string
  iParams: {
    group_by: string[]
    location_ids: number[]
    metrics: string[]
  }
}

export const LIST_BUSINESS_WEEKS = gql`
  query listBusinessWeeks($minYear: Int!, $maxYear: Int!) {
    listBusinessWeeks(minYear: $minYear, maxYear: $maxYear) {
      nodes {
        businessYear
        businessQuarter
        businessMonth
        businessWeek
        businessWeekOfMonth
        businessWeekBeginDate
        businessWeekEndDate
      }
    }
  }
`

export interface IBusinessWeekNode {
  businessYear: number
  businessQuarter: number
  businessMonth: number
  businessWeek: number
  businessWeekOfMonth: number
  businessWeekBeginDate: string
  businessWeekEndDate: string
}

export interface IListBusinessWeeksResponse {
  listBusinessWeeks: {
    nodes: IBusinessWeekNode[]
  }
}

export interface IListBusinessWeeksVariables {
  minYear: number
  maxYear: number
}

export const LIST_LOCATION_DETAILS_V2 = gql`
  query listLocationDetailsV2(
    $iStartDate: Date!
    $iEndDate: Date!
    $iFilter: JSON!
  ) {
    listLocationDetailsV2(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        id
        locationGroups
      }
    }
  }
`
export interface IListLocationDetailsV2Response {
  listLocationDetailsV2: {
    nodes: IListLocationDetailsV2Node[]
  }
}

export interface ILocationDetailsGroupType {
  id: number
  name: string
  type: string
  start_date: string
  end_date: string
}
export interface IListLocationDetailsV2Node {
  id: number
  locationGroups: ILocationDetailsGroupType[]
}

export interface IListLocationDetailsV2Variables {
  iStartDate: string
  iEndDate: string
  iFilter: {
    location_ids: number[]
  }
}

export const GET_DATE_INFO = gql`
  query getDateInfo($iQueryDate: Date!) {
    getDateInfo(iQueryDate: $iQueryDate) {
      nodes {
        queryDate
        businessYear
        businessWeek
      }
    }
  }
`

export interface IGetDateInfoNode {
  queryDate: string
  businessYear: number
  businessWeek: number
}

export interface IGetDateInfoResponse {
  getDateInfo: {
    nodes: IGetDateInfoNode[]
  }
}

export interface IGetDateInfoVariables {
  iQueryDate: string
}
